import React from 'react';
import {
  components as DefaultSelectComponents,
  ControlProps,
} from 'react-select';
import classNames from 'classnames';
import Button, {
  ButtonSizes,
  ButtonTypes,
} from '@lib/components/Button/Button';
import styles from '../Select.module.scss';

export default function ButtonControl(props: ControlProps): React.ReactElement {
  const { children, ...restProps } = props;
  const { selectProps, isFocused } = restProps;
  const {
    menuIsOpen,
    isDisabled,
    // @ts-ignore
    buttonControlProps = {},
    value,
  } = selectProps;
  const {
    buttonSize = ButtonSizes.large,
    buttonType = ButtonTypes.primaryOutlined,
    leftIcon,
  } = buttonControlProps;
  const controlClassName = classNames(styles.control, styles.buttonControl, {
    isFocused,
    isDisabled,
    menuIsOpen,
  });
  return (
    // @ts-ignore
    <DefaultSelectComponents.Control
      {...restProps}
      className={controlClassName}
    >
      <Button
        counter={Array.isArray(value) ? value.length : undefined}
        buttonText={children}
        buttonType={buttonType}
        buttonSize={buttonSize}
        isFocused={menuIsOpen}
        leftIcon={leftIcon}
        rightIcon={menuIsOpen ? 'arrow_drop_up' : 'arrow_drop_down'}
      />
    </DefaultSelectComponents.Control>
  );
}
